import apiClient from "../../utils/interceptor";
import { ApiResponse, CropData, CreateCropParams, UpdateCropParams, CreateCropResponse } from "./interface";
import { API_URLS } from "../../constants";

// Helper to get auth token
const getAuthToken = (): string | null => {
    return localStorage.getItem("auth_token");
};

// Function to get all crops
export const getAllCrops = async (): Promise<ApiResponse<CropData[]>> => {
    const token = getAuthToken();

    try {
        const response = await apiClient.get<ApiResponse<CropData[]>>(
            API_URLS.CROP.GET_CROPS,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching crops:", error);
        throw error;
    }
};

// Function to create a crop
export const createCrop = async (
    cropParams: CreateCropParams
): Promise<ApiResponse<CreateCropResponse>> => {
    const token = getAuthToken();

    try {
        const response = await apiClient.post<ApiResponse<CreateCropResponse>>(
            API_URLS.CROP.CREATE_CROP,
            cropParams,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error creating crop:", error);
        throw error;
    }
};

// Function to update a crop
export const updateCrop = async (
    cropData: UpdateCropParams
): Promise<ApiResponse<null>> => {
    const token = getAuthToken();

    try {
        const response = await apiClient.patch<ApiResponse<null>>(
            API_URLS.CROP.UPDATE_CROP,
            cropData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error updating crop:", error);
        throw error;
    }
};

// Function to delete (disable) a crop
export const deleteCrop = async (
    cropId: string
): Promise<ApiResponse<null>> => {
    const token = getAuthToken();

    try {
        const response = await apiClient.delete<ApiResponse<null>>(
            API_URLS.CROP.DELETE_CROP,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                data: { crop_id: cropId },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error deleting crop:", error);
        throw error;
    }
};
